<template>
  <q-tooltip>
    This field does not support non-English translations
  </q-tooltip>
</template>

<script>
export default {
  name: 'UntranslatableFieldTooltip'
}
</script>
